import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=5ec51446&scoped=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=5ec51446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec51446",
  null
  
)

export default component.exports